var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPolliaIconFilled = function SvgPolliaIconFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.97 0a3.54 3.54 0 0 1 3.395 2.54 4.8 4.8 0 0 1 6.105 6.067 3.542 3.542 0 0 1 0 6.786 4.8 4.8 0 0 1-6.077 6.077 3.54 3.54 0 0 1-6.787 0 4.8 4.8 0 0 1-6.077-6.077 3.54 3.54 0 0 1 0-6.787A4.8 4.8 0 0 1 8.58 2.52 3.54 3.54 0 0 1 11.97 0m0 7.08-.091-.003v.003a4.8 4.8 0 0 1-4.799 4.8l-.004-.001q.003.06.004.121-.001.06-.004.12h.004a4.8 4.8 0 0 1 4.8 4.8l-.001.003q.06-.002.121-.003l.12.003v-.003a4.8 4.8 0 0 1 4.8-4.8h.002a3 3 0 0 1 0-.241h-.002a4.8 4.8 0 0 1-4.8-4.799v-.005q-.075.004-.15.005"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 6,
    fill: "currentColor"
  })));
};
export default SvgPolliaIconFilled;